import './trailingSlash.js'
import './app.css'

const API_URL = process.env.API_URL || 'https://app.ducha.cards/api'
const SESSION_EMAIL_KEY = 'ducha:authEmail'

const bootLoading = document.getElementById('boot-loading')
const authView = document.getElementById('auth-view')
const homeView = document.getElementById('home-view')
const hostView = document.getElementById('host-view')
const partnerView = document.getElementById('partner-view')
const headerActions = document.getElementById('header-actions')
const headerEmail = document.getElementById('header-email')
const authFormPanel = document.getElementById('auth-form-panel')
const authSentPanel = document.getElementById('auth-sent-panel')
const authForm = document.getElementById('auth-form')
const authEmailInput = document.getElementById('auth-email')
const authRoleGroup = document.getElementById('auth-role')
const authSubmitBtn = document.getElementById('auth-submit')
const authResendBtn = document.getElementById('auth-resend-btn')
const authSentLead = document.getElementById('auth-sent-lead')
const authStatus = document.getElementById('auth-status')
const logoutBtn = document.getElementById('logout-btn')

let pendingAuthEmail = ''
let pendingAuthRole = 'host'

function getSelectedRole () {
  if (!authRoleGroup) return 'host'
  const checked = authRoleGroup.querySelector('input[name="auth-role"]:checked')
  return checked ? checked.value : 'host'
}

function hideBootLoading () {
  if (bootLoading) bootLoading.hidden = true
}

function getStoredAuthEmail () {
  try {
    return window.localStorage.getItem(SESSION_EMAIL_KEY) || ''
  } catch {
    return ''
  }
}

function rememberAuthEmail (email) {
  try {
    window.localStorage.setItem(SESSION_EMAIL_KEY, email)
  } catch {}
}

function setAuthStatus (message = '') {
  if (authStatus) authStatus.textContent = message
}

function setAuthBusy (busy) {
  if (authSubmitBtn) {
    authSubmitBtn.disabled = busy
    authSubmitBtn.textContent = busy ? 'Enviando…' : 'Enviar link de acesso'
  }
  if (authResendBtn) authResendBtn.disabled = busy
}

function showAuthFormPanel () {
  if (authFormPanel) authFormPanel.hidden = false
  if (authSentPanel) authSentPanel.hidden = true
  setAuthBusy(false)
  if (authEmailInput) authEmailInput.focus()
}

function showAuthSentPanel ({ email }) {
  if (authFormPanel) authFormPanel.hidden = true
  if (authSentPanel) authSentPanel.hidden = false
  if (authSentLead) {
    authSentLead.textContent = `Enviamos um link de acesso para ${email}. Abra-o neste dispositivo. O link expira em 15 minutos.`
  }
  setAuthBusy(false)
}

function showAuthView ({ message = '' } = {}) {
  hideBootLoading()
  authView.hidden = false
  if (homeView) homeView.hidden = true
  if (hostView) hostView.hidden = true
  if (partnerView) partnerView.hidden = true
  if (headerActions) headerActions.hidden = true
  pendingAuthEmail = ''
  if (authEmailInput) authEmailInput.value = getStoredAuthEmail() || ''
  showAuthFormPanel()
  setAuthStatus(message)
}

function showHomeView ({ email, role }) {
  hideBootLoading()
  authView.hidden = true
  if (headerActions) headerActions.hidden = false
  if (headerEmail) headerEmail.textContent = email

  const isPartner = role === 'partner'
  if (homeView) homeView.hidden = true
  if (hostView) hostView.hidden = isPartner
  if (partnerView) partnerView.hidden = !isPartner
}

async function apiRequest (path, options = {}) {
  const { retryAuth = true, ...fetchOptions } = options
  const headers = {
    'Content-Type': 'application/json',
    ...(fetchOptions.headers || {})
  }

  const response = await window.fetch(`${API_URL}${path}`, {
    ...fetchOptions,
    credentials: 'include',
    headers
  })

  if ((response.status === 401 || response.status === 410) && retryAuth && path !== '/auth/refresh') {
    const refreshResponse = await window.fetch(`${API_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })

    if (refreshResponse.ok) {
      return apiRequest(path, { ...options, retryAuth: false })
    }
  }

  if (!response.ok) {
    let message = `Request failed (${response.status})`
    try {
      const data = await response.json()
      message = data.error?.message || data.error || message
    } catch {}
    throw new Error(message)
  }

  if (response.status === 204) return null

  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    return response.json()
  }

  return null
}

async function requestMagicLink (email, role) {
  await apiRequest('/auth/magic-link', {
    method: 'POST',
    body: JSON.stringify({ email, role }),
    retryAuth: false
  })
  rememberAuthEmail(email)
  pendingAuthEmail = email
  pendingAuthRole = role
  showAuthSentPanel({ email })
  setAuthStatus('')
}

async function boot () {
  const params = new URLSearchParams(window.location.search)
  const authError = params.get('authError')
  if (authError) {
    params.delete('authError')
    const nextUrl = `${window.location.pathname}${params.toString() ? `?${params}` : ''}`
    window.history.replaceState({}, '', nextUrl)
    showAuthView({ message: decodeURIComponent(authError) })
    return
  }

  try {
    const data = await apiRequest('/auth/me')
    showHomeView({ email: data.user.email, role: data.user.role })
  } catch {
    showAuthView()
  }
}

if (authForm) {
  authForm.addEventListener('submit', async (event) => {
    event.preventDefault()
    const email = authEmailInput ? authEmailInput.value.trim() : ''
    if (!email) return

    setAuthBusy(true)
    setAuthStatus('')

    try {
      await requestMagicLink(email, getSelectedRole())
    } catch (error) {
      setAuthBusy(false)
      setAuthStatus(error.message || 'Não foi possível enviar o link.')
    }
  })
}

if (authResendBtn) {
  authResendBtn.addEventListener('click', async () => {
    const email = pendingAuthEmail || (authEmailInput ? authEmailInput.value.trim() : '')
    if (!email) {
      showAuthFormPanel()
      return
    }

    setAuthBusy(true)
    setAuthStatus('')

    try {
      await requestMagicLink(email, pendingAuthRole || getSelectedRole())
    } catch (error) {
      setAuthBusy(false)
      setAuthStatus(error.message || 'Não foi possível enviar o link.')
    }
  })
}

if (logoutBtn) {
  logoutBtn.addEventListener('click', async () => {
    try {
      await apiRequest('/auth/signout', { method: 'POST', body: '{}' })
    } catch {}
    showAuthView()
  })
}

// ── Step flow ────────────────────────────────────────────────────────────────

const CARDS = {
  gold:     { label: 'Acesso Wellness',     price: 'R$ 200' },
  platinum: { label: 'Acesso Wellness Plus', price: 'R$ 400' },
  black:    { label: 'Acesso Wellness Pro',  price: 'R$ 700' }
}

let checkinData = {}
let carouselIndex = 0
const carouselSlides = document.querySelectorAll('.carousel__slide')
const carouselTrack = document.getElementById('carousel-track')
const carouselDots = document.querySelectorAll('.carousel__dot')
const carouselPrev = document.getElementById('carousel-prev')
const carouselNext = document.getElementById('carousel-next')

function moveCarousel (index) {
  carouselIndex = (index + carouselSlides.length) % carouselSlides.length
  if (carouselTrack) carouselTrack.style.transform = `translateX(-${carouselIndex * 100}%)`
  carouselDots.forEach((d, i) => d.classList.toggle('carousel__dot--active', i === carouselIndex))
}

if (carouselPrev) carouselPrev.addEventListener('click', () => moveCarousel(carouselIndex - 1))
if (carouselNext) carouselNext.addEventListener('click', () => moveCarousel(carouselIndex + 1))

function goToStep (step) {
  for (let i = 1; i <= 4; i++) {
    const panel = document.getElementById(`step-${i}`)
    if (panel) panel.hidden = i !== step
  }
  document.querySelectorAll('.steps__item').forEach((el, i) => {
    const n = i / 2 + 1
    el.classList.toggle('steps__item--active', n === step)
    el.classList.toggle('steps__item--done', n < step)
  })
  document.querySelectorAll('.steps__line').forEach((el, i) => {
    el.classList.toggle('steps__line--done', i + 1 < step)
  })
}

function fillSummary (prefix) {
  const card = CARDS[checkinData.card] || {}
  const checkout = checkinData.checkout
    ? new Date(checkinData.checkout + 'T12:00:00').toLocaleDateString('pt-BR')
    : ''
  document.getElementById(`${prefix}-name`).textContent = checkinData.name || ''
  document.getElementById(`${prefix}-room`).textContent = checkinData.room || ''
  document.getElementById(`${prefix}-checkout`).textContent = checkout
  document.getElementById(`${prefix}-card`).textContent = card.label || ''
  document.getElementById(`${prefix}-price`).textContent = card.price || ''
}

const checkinForm = document.getElementById('checkin-form')
if (checkinForm) {
  checkinForm.addEventListener('submit', (e) => {
    e.preventDefault()
    checkinData.name = document.getElementById('checkin-name').value.trim()
    checkinData.room = document.getElementById('checkin-room').value.trim()
    checkinData.checkout = document.getElementById('checkin-checkout').value
    goToStep(2)
  })
}

const step2Back = document.getElementById('step2-back')
const step2Next = document.getElementById('step2-next')
if (step2Back) step2Back.addEventListener('click', () => goToStep(1))
if (step2Next) {
  step2Next.addEventListener('click', () => {
    const slide = carouselSlides[carouselIndex]
    checkinData.card = slide ? slide.dataset.value : ''
    fillSummary('summary')
    goToStep(3)
  })
}

const step3Back = document.getElementById('step3-back')
const step3Confirm = document.getElementById('step3-confirm')
if (step3Back) step3Back.addEventListener('click', () => goToStep(2))
if (step3Confirm) {
  step3Confirm.addEventListener('click', () => {
    fillSummary('receipt')
    goToStep(4)
  })
}

const step4Restart = document.getElementById('step4-restart')
if (step4Restart) {
  step4Restart.addEventListener('click', () => {
    checkinData = {}
    moveCarousel(0)
    const form = document.getElementById('checkin-form')
    if (form) form.reset()
    goToStep(1)
  })
}

// ── Mode tabs ─────────────────────────────────────────────────────────────────

const modeSell = document.getElementById('mode-sell')
const modeRedeem = document.getElementById('mode-redeem')
const sellFlow = document.getElementById('sell-flow')
const redeemFlow = document.getElementById('redeem-flow')

function setMode (mode) {
  const isSell = mode === 'sell'
  if (sellFlow) sellFlow.hidden = !isSell
  if (redeemFlow) redeemFlow.hidden = isSell
  if (modeSell) modeSell.classList.toggle('mode-tab--active', isSell)
  if (modeRedeem) modeRedeem.classList.toggle('mode-tab--active', !isSell)
}

if (modeSell) modeSell.addEventListener('click', () => setMode('sell'))
if (modeRedeem) modeRedeem.addEventListener('click', () => setMode('redeem'))

// ── Redeem flow ───────────────────────────────────────────────────────────────

// Stub: in production this would hit the API to look up the sale by room number.
// Here we simulate a found card based on the most-recent sell data.
const MOCK_SALES = {}

function goToRedeemStep (step) {
  document.getElementById('redeem-step-1').hidden = step !== 1
  document.getElementById('redeem-step-2').hidden = step !== 2
  document.getElementById('redeem-step-3').hidden = step !== 3
}

let redeemData = {}

const redeemForm = document.getElementById('redeem-form')
if (redeemForm) {
  redeemForm.addEventListener('submit', (e) => {
    e.preventDefault()
    const room = document.getElementById('redeem-room').value.trim()
    // Look up in mock store; fall back to a placeholder so the UI always works.
    const sale = MOCK_SALES[room] || { name: '—', room, card: 'gold', checkout: '' }
    const card = CARDS[sale.card] || { label: sale.card, price: '—' }
    redeemData = { ...sale, cardLabel: card.label, cardPrice: card.price }
    document.getElementById('redeem-summary-name').textContent = redeemData.name
    document.getElementById('redeem-summary-room').textContent = redeemData.room
    document.getElementById('redeem-summary-card').textContent = redeemData.cardLabel
    document.getElementById('redeem-summary-price').textContent = redeemData.cardPrice
    goToRedeemStep(2)
  })
}

const redeemBack = document.getElementById('redeem-back')
if (redeemBack) redeemBack.addEventListener('click', () => goToRedeemStep(1))

const redeemConfirm = document.getElementById('redeem-confirm')
if (redeemConfirm) {
  redeemConfirm.addEventListener('click', () => {
    document.getElementById('redeem-receipt-name').textContent = redeemData.name
    document.getElementById('redeem-receipt-room').textContent = redeemData.room
    document.getElementById('redeem-receipt-card').textContent = redeemData.cardLabel
    document.getElementById('redeem-receipt-price').textContent = redeemData.cardPrice
    goToRedeemStep(3)
  })
}

const redeemRestart = document.getElementById('redeem-restart')
if (redeemRestart) {
  redeemRestart.addEventListener('click', () => {
    redeemData = {}
    const form = document.getElementById('redeem-form')
    if (form) form.reset()
    goToRedeemStep(1)
  })
}

// Store completed sales so redeem can look them up in the same session.
const origStep3Confirm = document.getElementById('step3-confirm')
if (origStep3Confirm) {
  origStep3Confirm.addEventListener('click', () => {
    if (checkinData.room) {
      MOCK_SALES[checkinData.room] = { ...checkinData }
    }
  }, true)
}

boot()
